export enum Competition {
  CompetitionA = '39df9ec8-be91-4be5-1925-4b670a4cbed9',
  CompetitionB = '39df9ec8-becb-86ea-b5e8-600c1b47968d'
}

export enum MetricMode {
  Match = 'matchMetricResult',
  Accumulated = 'accumulatedMetricResult',
  Acumulated = 'acumulatedMetricResult', // KEEP: BE send this typo. Don't delete it
  Average = 'averageMetricResult',
  Maximum = 'maximumMetricResult'
}

export enum MatchTab {
  Previous = 'MTR_METRICCATEGORY_PREVIA',
  LineUp = 'MTR_METRICCATEGORY_LINEUP',
  Overview = 'MTR_METRICCATEGORY_PARTIDO',
  MatchEvents = 'MTR_MATCH_EVENTS'
}
